import { definePath } from '../../router/definePath';

export const OrdersPaths = {
  orders: definePath('authenticated', { de: '/konto/bestellungen', en: '/account/orders' }),
} as const;
